import { OverlayContainer } from '@angular/cdk/overlay';
import { Directive, ElementRef, Renderer2, OnInit, Input } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { isNil } from 'lodash-es';
import { IThemeDirectiveProvider } from '../../modal/i-theme-directive.provider';

@UntilDestroy()
@Directive({
  selector: '[nimbusTheme]',
  standalone: false,
})
export class NimbusThemeDirective implements OnInit {
  private contextStyle: number;

  private themeNames = ['theme-default', 'theme-dark', 'theme-contrast'];

  @Input() public target: ElementRef;

  public constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private readonly themeDirectiveProvider: IThemeDirectiveProvider,
    private readonly overlayContainer: OverlayContainer,
  ) {}

  public ngOnInit(): void {
    this.target = this.target || this.el;
    this.themeDirectiveProvider
      .getTheme()
      .pipe(untilDestroyed(this))
      .subscribe((themeStyle) => {
        this.applyStyle(themeStyle);
      });
  }

  public applyStyle(themeStyle: number): void {
    if (!isNil(this.contextStyle)) {
      this.renderer.removeClass(this.target.nativeElement, this.themeNames[this.contextStyle]);
      this.renderer.removeClass(this.overlayContainer.getContainerElement(), this.themeNames[this.contextStyle]);
    }
    this.contextStyle = themeStyle;
    this.renderer.addClass(this.target.nativeElement, this.themeNames[this.contextStyle]);
    this.renderer.addClass(this.overlayContainer.getContainerElement(), this.themeNames[this.contextStyle]);
  }
}
